import { render, staticRenderFns } from "./card_cider_stats.vue?vue&type=template&id=67624e75&scoped=true"
import script from "./card_cider_stats.vue?vue&type=script&lang=js"
export * from "./card_cider_stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67624e75",
  null
  
)

export default component.exports